import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  padding: 2rem 0;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  text-align: center;
`;

const Contact = () => {
  return (
    <Container>
      <Content>
        <h1>Contact Us</h1>
        <p>Get in touch with the NourishGY team.</p>
      </Content>
    </Container>
  );
};

export default Contact;
